import React from "react";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers/TimePicker";
import TextField from "@mui/material/TextField";

const TimePicker = ({ label, value, onChange, sx = {}, ...props }) => (
  <MuiTimePicker
    label={label}
    value={value}
    onChange={onChange}
    renderInput={(params) => <TextField {...params} sx={sx} />}
    {...props}
  />
);

export default TimePicker;
